import React from 'react'
import { QueryImage } from "../hooks/queensberryImgs1.js";
import Img from 'gatsby-image';

const queensberryImgs = () => {
    const allFile = QueryImage()
    return (
        <div>
            {
                allFile.edges.map((el, i) => (
                    <div key={i}>
                        <Img
                            fluid={el.node.childImageSharp.fluid}
                            alt="Photo"
                            className="image-fluid"
                        />
                        <br />
                    </div>
                ))
            }
        </div>
    )
}

export default queensberryImgs